import {
    SCHEDULE_POLICY_KIND_DEFAULT_ANCHORS,
    SCHEDULE_POLICY_KIND_MODES,
    SchedulePolicyKind,
} from "@common/helpers/domains/accounting/schedulePolicyKind";
import { ScheduleTemplateFormValues } from "./scheduleFormHelpers";

/**
 * Picking another kind clears the holding accounts it no longer allows, and
 * the recognition accounts too when the type flips between revenue and
 * expense. Rows still on the old kind's default anchor move to the new one.
 */
export function changeSchedulePolicyKind(
    values: Pick<
        ScheduleTemplateFormValues,
        "kind" | "accountBlocks" | "components"
    >,
    kind: SchedulePolicyKind,
): Pick<ScheduleTemplateFormValues, "kind" | "accountBlocks" | "components"> {
    const isTypeChanged =
        SCHEDULE_POLICY_KIND_MODES[values.kind].type !==
        SCHEDULE_POLICY_KIND_MODES[kind].type;
    const previousDefaultAnchor =
        SCHEDULE_POLICY_KIND_DEFAULT_ANCHORS[values.kind];
    return {
        kind,
        accountBlocks: values.accountBlocks.map((block) => ({
            ...block,
            holdingAccountName: null,
            recognitionAccountName: isTypeChanged
                ? null
                : block.recognitionAccountName,
        })),
        components: values.components.map((component) =>
            component.anchor === previousDefaultAnchor
                ? {
                      ...component,
                      anchor: SCHEDULE_POLICY_KIND_DEFAULT_ANCHORS[kind],
                  }
                : component,
        ),
    };
}
